import { TranslationKey } from './en'

// Typed against en.ts: a missing or extra key fails `npm run type-check`. Wording follows the app's
// `bw-react-frontend/packages/bw-locale/src/fr` where the same string exists (Fermer, Afficher plus, Menu,
// Frais annuels, Voir le produit, S.O., Montant du prêt, Terme, Faire une demande).
export const fr: Record<TranslationKey, string> = {
  'blog.minRead': '{{readTime}} min de lecture',
  'blogCatalog.title': 'Catalogue du blogue',
  'blogCatalog.categories': 'Catégories du blogue',
  'blogCatalog.allBlogs': 'Tous les articles',
  'blogCatalog.loadMore': 'Afficher plus',
  'blogCatalog.loadedMore': '{{count}} articles de plus chargés ci-dessus',
  'blogCatalog.searchLabel': 'Rechercher un mot-clé ou un sujet',
  'blogCatalog.searchResultsFor': 'Résultats de recherche pour :',
  'blogCatalog.searchingWithin': 'Recherche dans',
  'blogCatalog.showingResultsFor': 'Résultats pour',
  'blogCatalog.backToAllBlogs': '< Retour à tous les articles',
  'creditCard.annualFee': 'Frais annuels',
  'creditCard.purchaseInterestRate': 'Taux d’intérêt sur les achats',
  'creditCard.cashAdvanceRate': 'Taux sur les avances de fonds',
  'creditCard.balanceTransferRate': 'Taux sur les transferts de solde',
  'creditCard.notApplicable': 'S.O.',
  'creditCard.viewProduct': 'Voir le produit',
  'creditCard.viewProductFor': 'Voir le produit {{productTitle}}',
  'creditCard.showDetails': 'Afficher les détails',
  'creditCard.hideDetails': 'Masquer les détails',
  'creditCard.showDetailsFor': 'Afficher les détails de {{productTitle}}',
  'creditCard.hideDetailsFor': 'Masquer les détails de {{productTitle}}',
  'creditCard.imageAlt': 'Carte de crédit {{productTitle}}',
  'loan.provider': 'Prêteur',
  'loan.loanAmount': 'Montant du prêt',
  'loan.interestRate': 'Taux d’intérêt',
  'loan.term': 'Terme',
  'loan.applyNow': 'Faire une demande',
  'loan.applyNowFor': 'Faire une demande de prêt auprès de {{companyName}}',
  'personalLoanCalculator.infoTitle': 'Renseignements sur le prêt personnel',
  'personalLoanCalculator.amount': 'Montant',
  'personalLoanCalculator.amountError': 'Le montant doit être un nombre positif',
  'personalLoanCalculator.rate': 'Taux',
  'personalLoanCalculator.rateError': 'Le taux doit être un nombre entier positif',
  'personalLoanCalculator.loanTerm': 'Terme du prêt (mois)',
  'personalLoanCalculator.loanTermError': 'Le terme du prêt doit être un nombre entier positif',
  'personalLoanCalculator.calculate': 'Calculer',
  'personalLoanCalculator.paymentTitle': 'Paiement du prêt personnel',
  'personalLoanCalculator.monthlyPayment': 'Paiement mensuel',
  'personalLoanCalculator.interestCost': 'Coût des intérêts pour le terme',
  'personalLoanCalculator.announcement':
    'Paiement mensuel : {{monthlyPayment}}\nCoût des intérêts pour le terme : {{interestCost}}',
  'header.menu': 'Menu',
  'header.close': 'Fermer',
  'header.openMenu': 'Ouvrir le menu',
  'header.closeMenu': 'Fermer le menu',
  'header.submenu': 'Sous-menu {{linkText}}',
  'icon.chevronDown': 'Chevron vers le bas',
  'icon.chevronUp': 'Chevron vers le haut',
  'icon.caretDown': 'Flèche vers le bas',
  'icon.chevronThick': 'Chevron épais',
  'input.clearSearch': 'Effacer la recherche',
  'snackBar.dismiss': 'fermer',
  'metadata.description': 'Borrowell aide les Canadiens à prendre de bonnes décisions en matière de crédit.',
  'metadata.keywords':
    'rapport Equifax gratuit, cote de crédit Canada, comment vérifier sa cote de crédit, dossier de crédit annuel Canada',
  'metadata.blogTitle': 'The Well – Blogue sur les finances personnelles',
  'metadata.blogDescription':
    'Obtenez des conseils, des outils et des ressources pour améliorer votre santé financière et vous sentir en contrôle et optimiste face à votre avenir.',
  'metadata.blogKeywords': 'blogue Borrowell, finances personnelles, cote de crédit',
}
